import {FormControlLabel, FormGroup, Switch} from "@mui/material";
import React from "react";
import {useStores} from "../../../../../../stores";
import {observer} from "mobx-react-lite";
import {plural} from "../../../../../../utils/js-utils.ts";

export const ToolbarToggleGroupBy: React.FC = observer(() => {
    const {p, categorizationReviewStore} = useStores()
    const pageController = categorizationReviewStore.reviewPageController;
    const isGroupBy = pageController.isGroupBy;
    const toggleGroupBy = () => {
        pageController.setIsGroupBy(!isGroupBy);
    }
    return (
        <FormGroup sx={{mx: 1}}>
            <FormControlLabel
                control={<Switch
                        color="info"
                        size="small"
                        checked={isGroupBy}
                        onChange={toggleGroupBy}
                />}
                label={`Group by ${plural(p.supplierDataName).toLowerCase()}`}
            />
        </FormGroup>
    )
})
